import http from '../httpService';

const MaterialService = {
  getMaterialService: params => http.get('material', { params }),
};

export default MaterialService;
